import { render, staticRenderFns } from "./CookieSettingsModal.vue?vue&type=template&id=1215fdb8&scoped=true&"
import script from "./CookieSettingsModal.vue?vue&type=script&lang=js&"
export * from "./CookieSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./CookieSettingsModal.vue?vue&type=style&index=0&id=1215fdb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215fdb8",
  null
  
)

export default component.exports